import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import getSafeSpacing from '../../common/getSafeSpacing';
import infoTile from '../../images/company/info_tile.png';
import infoSlogan from '../../images/company/info_slogan.png';

const CompanyPage = () => (
  <Grid container spacing={getSafeSpacing(4)} className="noselect">
    <Grid item sm={6} xs={12}>
      <Typography variant="h4">
        <b style={{ color: '#ff8d08' }}>나눔과 실천</b>
        <br />
        <span style={{ color: '#4b5989' }}>
          <b>{process.env.REACT_APP_COMPANY}</b>
          이 추구하는
          <br />
          <b>가치</b>
          입니다.
        </span>
      </Typography>
      <Typography variant="h6">
        안녕하세요^^
        <br />
        홈페이지 방문을 진심으로 환영합니다.
      </Typography>
      <Typography variant="body1">
        타일 줄눈시공 회사
        {' '}
        {process.env.REACT_APP_COMPANY}
        입니다.
        <br />
        본사는 줄눈 시공만을 전문으로 하는 회사입니다.
        <br />
        성실시공, 완벽한 시공과 사후관리를 해드리고 있습니다.
        <br />
        앞으로도 줄눈시공을 전문으로하는 업체로서 최선을 다하겠습니다.
      </Typography>
      <br />
      <br />
      <Typography variant="body1" style={{ textAlign: 'right' }}>
        <b>
          -
          {process.env.REACT_APP_COMPANY}
          {' '}
          임직원 일동
        </b>
      </Typography>
    </Grid>
    <Grid sm={6} xs={12}>
      <img src={infoTile} alt="타일 줄눈" style={{ width: '100%' }} />
    </Grid>
    <Grid xs={12}>
      <img
        src={infoSlogan}
        alt="슬로건. 나눔, 실천과 책임, 지속"
        style={{ width: '100%' }}
      />
    </Grid>
  </Grid>
);

export default CompanyPage;
